export function AppIconSettingsScreen() {
  throw new Error('Not supported on web')
}
